import { Tooltip } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import GetApp from '@mui/icons-material/GetApp';
import * as FileSaver from 'file-saver';
import writeExcelFile from 'write-excel-file/browser';
import AdminTrackExportConfigData from '../../config/AdminTrackExportConfig.json';

const ExportAdminTrackCSV = ({ csvData, fileName }) => {
    const fileExtension = '.xlsx';

    const exportToCSV = async (csvData, fileName) => {
        const columns = AdminTrackExportConfigData.columns;
        const dcrData = [];
        const mergeData = [];
        const subscriptionData = [];
        const employerData = [];
        csvData.forEach((row) => {
            const requestType = row['RequestType'];
            
            if (requestType === 'DCR') {
                const dcrRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        dcrRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        dcrRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        dcrRow[column.label] = row[columnId];
                    }
                });
                dcrData.push(dcrRow);
            } else if (requestType === 'Direct-Employer') {
                const employerRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        employerRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        employerRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        employerRow[column.label] = row[columnId];
                    }
                });
                employerData.push(employerRow);
            } else if (requestType === 'Merge') {
                const mergeRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        mergeRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        mergeRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        mergeRow[column.label] = row[columnId];
                    }
                });
                mergeData.push(mergeRow);
            } else if (requestType === 'Subscription') {
                const subscriptionRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        subscriptionRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        subscriptionRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        subscriptionRow[column.label] = row[columnId];
                    }
                });
                subscriptionData.push(subscriptionRow);
            }
        });

        const buildSheet = (data, sheetName) => {
            const headerRow = columns.map(column => ({
                value: column.label,
                fontWeight: 'bold',
            }));

            const dataRows = data.length
                ? data.map(row => columns.map(column => ({ value: row[column.label] ?? '' })))
                : [columns.map(() => ({ value: '' }))];

            const colWidths = columns.map(column => {
                const maxLen = Math.max(
                    ...data.map(row => (row[column.label] ? row[column.label].toString().length : 0)),
                    column.label.length
                );
                return { width: Math.max(20, maxLen + 2) };
            });

            return {
                sheet: sheetName,
                columns: colWidths,
                data: [headerRow, ...dataRows],
                stickyRowsCount: 1,
            };
        };

        const sheets = [
            buildSheet(dcrData, 'DCR'),
            buildSheet(mergeData, 'Merge'),
            buildSheet(subscriptionData, 'Subscription'),
            buildSheet(employerData, 'Direct-Employer'),
        ];

        const blob = await writeExcelFile(sheets).toBlob();
        FileSaver.saveAs(blob, fileName + fileExtension);
    };

    return (
        <ToggleButton
            value="list"
            size="small"
            className="border-0 float-end"
            aria-label="list"
            onClick={(e) => exportToCSV(csvData, fileName)}
        >
            <Tooltip disableFocusListener title="Export" id="tooltip" >
                <GetApp />
            </Tooltip>
        </ToggleButton>
    );
};

export default ExportAdminTrackCSV;